import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import axios from 'axios';
import { BASE_URL } from '../../App';
import {
  Card, Button, MenuItem, Select, InputLabel, FormControl, Table, TableBody, TableCell, 
  TableContainer, TableHead, TableRow, Paper, Box,
} from '@mui/material';
import { Autocomplete, TextField } from '@mui/material';
import Grid from '@mui/material/Grid';

const SCR_Status_Report = () => {
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [status, setStatus] = useState('ALL');
  const [data, setData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [years, setYears] = useState([2023, 2024, 2025]);
  const loginId = localStorage.getItem("LOGIN_ID");
  const userGroupCode = localStorage.getItem("GROUP_CODE");
      const branchCode = localStorage.getItem("BRANCH_CODE")

  



  const validateInputs = () => {
    if (!month || !year || !status ) {
      Swal.fire({
        icon: 'error',
        title: 'Missing Fields',
        text: 'Please fill all required fields!',
      });
      return false;
    }
    return true;
  };

  const fetchData = async () => {
    if (!validateInputs()) return;

    Swal.fire({
      title: 'Fetching data...',
      html: 'Please wait while we fetch the data.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading(); 
      },
    });

    setLoading(true);
    try {
      const requestData = {
        Branchcode: branchCode,  
        Usergroupcode: userGroupCode,  
        loginId: loginId,
        selectedMonth: month,  
        selectedYear: year,    
        statusFilter: status,  
      };

      console.log('Request Data:', requestData); 

      const response = await axios.post(BASE_URL + '/getreportdata', requestData);

      console.log('API Response:', response); 

      if (response.status === 200) {
        const reportData = response.data.data;
        if (reportData === 'No Data Found') {
          Swal.fire({
            icon: 'info',
            title: 'No Data Found',
            text: 'No records found for the selected filters.',
          });
        } else {
          setData(reportData);
          setShowTable(true);
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'An error occurred while fetching the report.',
        });
      }
    } catch (error) {
      setError(error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'An error occurred while fetching the report.',
      });
    } finally {
      Swal.close();
      setLoading(false);
    }
  };

  const handleDownloadExcel = () => {
    if (data.length === 0) {
      Swal.fire({
        icon: 'error',
        title: 'No Data to Download',
        text: 'There is no data available to download!',
      });
      return;
    }

    Swal.fire({
      title: 'Download Excel?',
      text: 'Do you want to download the SCR Status Report as an Excel file?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, download it!',
      cancelButtonText: 'No, cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        const ws = XLSX.utils.json_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'SCR_Status_Report');
        XLSX.writeFile(wb, 'SCR_Status_Report.xlsx');

        Swal.fire({
          icon: 'success',
          title: 'Download Started',
          text: 'The Excel file is being downloaded.',
        });
      }
    });
  };

  return (
    <Box display="flex" flexDirection="column" justifyContent="flex-start" alignItems="center" sx={{ padding: 2 }}>
      <Card sx={{ padding: 3, width: '100%', maxWidth: 1500, marginBottom: 3 }}>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth>
              <Autocomplete
                value={month}
                onChange={(e, newValue) => setMonth(newValue)}
                options={['All', ...Array.from({ length: 12 }, (_, i) => new Date(0, i).toLocaleString('en', { month: 'short' }))]}
                getOptionLabel={(option) => option}
                sx={{ width: '300px' }}
                renderInput={(params) => <TextField {...params} label="Month" />}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth>
              <Autocomplete
                value={year}
                onChange={(e, newValue) => setYear(newValue)}
                options={years}
                sx={{ width: '300px' }}
                renderInput={(params) => <TextField {...params} label="Year" />}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <FormControl fullWidth>
              <Autocomplete
                value={status}
                onChange={(e, newValue) => setStatus(newValue)}
                options={['ALL', 'PENDING', 'APPROVED', 'REJECTED']}
                renderInput={(params) => <TextField {...params} label="Status" />}
                sx={{ width: '300px' }}
              />
            </FormControl>
          </Grid>
        </Grid>

        <Box mt={3}>
          <Button 
            variant="contained" 
            color="primary" 
            sx={{ mr: 2 }} 
            onClick={fetchData}  
          >
            View
          </Button>
          <Button 
            variant="contained" 
            color="success" 
            onClick={handleDownloadExcel}
          >
            Download Excel
          </Button>
        </Box>
      </Card>

      {loading && <div>Loading...</div>}
      {error && <div>Error occurred while fetching data</div>} 

      {showTable && (
        <Box sx={{ width: '100%', marginTop: 3 }}>
          <TableContainer component={Paper} sx={{ maxHeight: 680, overflowX: 'auto' }}>
            <Table sx={{ minWidth: 650 }} aria-label="SCR Status Report Table">
              <TableHead sx={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#1976d2' }}>
                <TableRow>
                  <TableCell style={{ color: 'white' }}>BranchCode</TableCell>
                  <TableCell style={{ color: 'white' }}>SCR_DealerCode</TableCell>
                  <TableCell style={{ color: 'white' }}>SerialNo</TableCell>
                  <TableCell style={{ color: 'white' }}>TokenNumber</TableCell>
                  <TableCell style={{ color: 'white' }}>DOC_NO</TableCell>
                  <TableCell style={{ color: 'white' }}>SCR_NO</TableCell>
                  <TableCell style={{ color: 'white' }}>SCR_DATE</TableCell>
                  <TableCell style={{ color: 'white' }}>MAT_CODE</TableCell>
                  <TableCell style={{ color: 'white' }}>ItemDesc</TableCell>
                  <TableCell style={{ color: 'white' }}>PSG_Desce</TableCell>
                  <TableCell style={{ color: 'white' }}>BILL_NO</TableCell>
                  <TableCell style={{ color: 'white' }}>BILL_DATE</TableCell>
                  <TableCell style={{ color: 'white' }}>Req_Total_Spares_Cost</TableCell>
                  <TableCell style={{ color: 'white' }}>Req_Service_Charge</TableCell>
                  <TableCell style={{ color: 'white' }}>App_Tot_SparesCost</TableCell>
                  <TableCell style={{ color: 'white' }}>App_Service_Charge</TableCell>
                  <TableCell style={{ color: 'white' }}>SERVICE_TYPE</TableCell>
                  <TableCell style={{ color: 'white' }}>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.length > 0 ? (
                  data.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item.BRANCH_CODE}</TableCell>
                      <TableCell>{item.SCR_DEALERCODE}</TableCell>
                      <TableCell>{item.SERIAL_NO}</TableCell>
                      <TableCell>{item.Tokennumber}</TableCell>
                      <TableCell>{item.DOC_NO}</TableCell>
                      <TableCell>{item.SCR_NO}</TableCell>
                      <TableCell>{item.SCR_DATE}</TableCell>
                      <TableCell>{item.MAT_CODE}</TableCell>
                      <TableCell>{item.ITEMDESC}</TableCell>
                      <TableCell>{item.PSG_DESCR}</TableCell>
                      <TableCell>{item.BILL_NO}</TableCell>
                      <TableCell>{item.BILL_DATE}</TableCell>
                      <TableCell>{item.Req_Total_Spares_Cost}</TableCell>
                      <TableCell>{item.Req_Service_Charge}</TableCell>
                      <TableCell>{item.App_Tot_SparesCost}</TableCell>
                      <TableCell>{item.App_Service_Charge}</TableCell>
                      <TableCell>{item.SERVICE_TYPE}</TableCell>
                      <TableCell>{item.STATUS}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={18} align="center">
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      )}
    </Box>
  );
};

export default SCR_Status_Report;






















